// Sentry error tracking for the browser. Must be imported FIRST in index.js.
// No-ops entirely when REACT_APP_SENTRY_DSN is unset (local development).
import * as Sentry from '@sentry/react';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV || 'development',
    // Never send PII: no user email/IP, and strip auth material from events.
    sendDefaultPii: false,
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE) || 0,
    beforeSend(event) {
      if (event.request && event.request.headers) {
        delete event.request.headers.authorization;
        delete event.request.headers.cookie;
      }
      if (event.user) {
        event.user = { id: event.user.id };
      }
      return event;
    },
    initialScope: { tags: { runtime: 'frontend' } }
  });
}

export default Sentry;
